import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { shortenText } from "utils/shorten-text";
import TrackMenu from "../track-menu";
import { useNavigate } from "react-router-dom";
import DateConvert from "utils/dateConvert";
import api from "services/axiosInstance";
import { ReleaseContainerWithUrls, SongWithUrls } from "types/response-type";
import TakedownTrackModal from "components/modal/modals/takedown-track-modal";
import Modal from "components/modal";
interface IProps {
  data: SongWithUrls | ReleaseContainerWithUrls;
}

// Type guard to check if the data is ITrackRelease
export const isTrackRelease = (
  data: SongWithUrls | ReleaseContainerWithUrls
): data is SongWithUrls => {
  return "releaseType" in data;
};

const TrackListItem = ({ data }: IProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use type guard to determine which type we're dealing with
  const isTrack = isTrackRelease(data);

  const {
    releaseType: type,
    primaryArtist: artist,
    coverArtPath: coverImage,
    trackNumber: noOfTracks,
    proposedReleaseDate: releaseDate,
    status,
    title
  } = isTrack
    ? data
    : {
        releaseType: data.type,
        // primaryArtist: { name: data.tracks[0].primaryArtistId },
        primaryArtist: { name: "Artist name" },
        coverArtPath: data.coverArtPath,
        trackNumber: data.totalTracks,
        proposedReleaseDate: data.tracks[0].proposedReleaseDate,
        status: data.status,
        title: data.title
      };

  const OpenTrackPage = () => {
    navigate(
      `/overview/discography/track/${data.id}?type=${
        isTrack ? type : data.type
      }`
    );
  };

  useEffect(() => {
    const GetImage = async () => {
      try {
        const response = await api.get(`${coverImage}`);
        console.log(response);
      } catch (err) {}
    };
    GetImage();
  }, []);

  const TakedownTrack = () => {};

  return (
    <>
      <tr onDoubleClick={OpenTrackPage}>
        <td>
          <DiscographyTitle>
            <DiscographyListImage
              src={isTrack ? coverImage : data.coverArtPath}
              alt="discography"
            />
            <div>
              <div style={{ cursor: "pointer" }} onClick={OpenTrackPage}>
                <Typography color={Colors.white300} weight={"medium"} mb="0.4">
                  {title}
                </Typography>
              </div>

              <Typography size="s" color={Colors.grey400}>
                {shortenText(artist?.name, 50)}
              </Typography>
            </div>
          </DiscographyTitle>
        </td>
        <td>
          <Typography color={Colors.white300} mr="5">
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </Typography>
        </td>
        <td>
          <Typography color={Colors.white300} mr="5">
            {noOfTracks || 1} Track
          </Typography>
        </td>
        <td>
          <Typography color={Colors.white300} mr="3">
            {DateConvert(new Date(releaseDate))}
          </Typography>
        </td>
        <td>
          <StatusContainer>
            <Status status={status} />
            <Typography color={Colors.white300} mr="3">
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </Typography>
            <ThreeDots onClick={() => setOpenMenu(true)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path
                  d="M8.02409 5.16716C7.28769 5.16716 6.69076 4.5702 6.69076 3.83382C6.69076 3.09744 7.28769 2.50049 8.02409 2.50049C8.76049 2.50049 9.35742 3.09744 9.35742 3.83382C9.35742 4.5702 8.76049 5.16716 8.02409 5.16716Z"
                  fill="#CDCDCD"
                />
                <path
                  d="M8.00065 9.83317C7.26425 9.83317 6.66732 9.23624 6.66732 8.49984C6.66732 7.76344 7.26425 7.1665 8.00065 7.1665C8.73705 7.1665 9.33398 7.76344 9.33398 8.49984C9.33398 9.23624 8.73705 9.83317 8.00065 9.83317Z"
                  fill="#CDCDCD"
                />
                <path
                  d="M7.97331 14.5002C7.23691 14.5002 6.63997 13.9032 6.63997 13.1668C6.63997 12.4304 7.23691 11.8335 7.97331 11.8335C8.70971 11.8335 9.30664 12.4304 9.30664 13.1668C9.30664 13.9032 8.70971 14.5002 7.97331 14.5002Z"
                  fill="#CDCDCD"
                />
              </svg>
            </ThreeDots>
          </StatusContainer>
          <TrackMenu
            isopen={openMenu}
            closeMenu={(value) => setOpenMenu(false)}
            trackId={data.id}
            type={type}
            takedown={() => setIsModalOpen(true)}
          />
        </td>
      </tr>
      <Modal isActive={isModalOpen} closeModal={() => setIsModalOpen(false)}>
        <TakedownTrackModal
          closeModal={() => setIsModalOpen(false)}
          confirm={TakedownTrack}
          name={title}
        />
      </Modal>
    </>
  );
};

export default TrackListItem;

const DiscographyTitle = styled.div`
  padding-left: 3.2rem;
  display: flex;
  align-items: center;
`;

const DiscographyListImage = styled.img`
  width: 3.3rem;
  height: 3.3rem;
  border-radius: 0.4rem;
  margin-right: 1.6rem;
  object-fit: scale-down;
`;

const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const Status = styled.div<{ status: string }>`
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.6rem;
  border-radius: 50%;
  position: relative;
  background-color: ${(props) =>
    props.status === "released"
      ? Colors.success
      : props.status === "inactive"
      ? Colors.danger
      : Colors.yellow500};
`;
const ThreeDots = styled.div`
  cursor: pointer;
  width: 1.6rem;
  margin-right: 1.6rem;
  margin-left: auto;
  position: relative;
`;
